import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './sidenav.css';
import config from 'config';

import axios from 'axios';
class SideNav extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sidebarData: []
        };
    }

   componentDidMount() {
    axios.get(`${config.RootUrl}/faculty/summary/moduleNavigation.json`)
      .then(res => {
        const sidebarData = res.data;
        this.setState({ sidebarData });
      })
  }
      
    closeNav = () => {
        document.getElementById("mySidenav").style.width = "0";
    }
 
    render() {
        return(
            <div id="mySidenav" className="sidenav">
                <div align="center" className="board">
                    <span onClick={this.closeNav} className="icon-cross">X</span>
                    <br />
                    <img className="rounded-circle" src={this.props.userPic}   style={{cursor:'pointer'}}  onClick={this.props.sideBarShowProfile}/>
                    <br />
                    <br />
                    <p>{this.props.email}</p>
                    <br />
                </div>
                <div className="navlinks">

                    {this.state.sidebarData.map(menu=>{
                        return(
                            <a href={config.RootUrl + menu.url  }>
                            <span className="sidenav-icon">
                                <FontAwesomeIcon icon={[menu.iconType, menu.iconName]} />
                            </span>
                            {menu.title}
                        </a>
                        )
                    })}
                    <br></br>
                    <br></br>
                    <br></br>
                </div>
            </div>
        );
    }
}

export default SideNav;